<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-parker' | translate}}</div>
  <app-parker-registration-detail-parker-details [parker]="parkingSession.knownTag?.parker"
    [companyName]="parkingSession.knownTag?.parker?.company?.name" [knownTag]="parkingSession.knownTag"
    [unknowParkerTagFull]="parkingSession.unknownParkerTagCountryCode ? parkingSession.unknownParkerTagCountryCode + ' ' + parkingSession.unknownParkerTagControlPlateNumber : parkingSession.unknownParkerTagControlPlateNumber">
  </app-parker-registration-detail-parker-details>
</div>

<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-session' | translate}}</div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.parkingDuration' | translate}}</label>
      <div>{{getParkingDuration()}}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.zone' | translate}}</label>
      <div>{{parkingSession.registeredZone.name}}</div>
    </div>
  </div>
  @if (parkingSession.subscription) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
        <div>{{parkingSession.subscription.name}}</div>
      </div>
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription-type' | translate}}</label>
        <div>{{getSubscriptionType(parkingSession.subscription) | translate}}</div>
      </div>
    </div>
  }
  @if (!parkingSession.subscription) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
        <div>{{'i18n.domain.parker-registration.fields.no-subscription' | translate}}</div>
      </div>
    </div>
  }
  @if (parkingSession.detailedPriceInformation || parkingSession.calculationRoadmap) {
    <hr class="mt-4 mb-4">
    <div class="form-row row">
      @if (parkingSession.detailedPriceInformation) {
        <div class="col-md-6">
          <label class="control-label">{{'i18n.domain.parker-registration.parking-price-tooltip.calculation' | translate}}</label>
          <div class="inner-card price-breakdown">
            <div class="price-line">
              <span>{{'i18n.domain.parker-registration.parking-price-tooltip.parking-price' | translate}}</span>
              <span>{{formatPrice(parkingSession.detailedPriceInformation.parkingPrice)}} {{('i18n.shared.currencies.' + Currency[parkingSession.detailedPriceInformation.currency]) | translate}}</span>
            </div>
            <div class="price-line price-sub">
              <span>{{'i18n.domain.parker-registration.parking-price-tooltip.vat-included' | translate}}</span>
              <span>{{formatPrice(parkingSession.detailedPriceInformation.parkingPriceIncludedVAT)}} {{('i18n.shared.currencies.' + Currency[parkingSession.detailedPriceInformation.currency]) | translate}}</span>
            </div>
            <div class="price-line">
              <span>{{'i18n.domain.parker-registration.parking-price-tooltip.service-fee' | translate}}</span>
              <span>{{formatPrice(parkingSession.detailedPriceInformation.parkingTransactionFeesConstant + parkingSession.detailedPriceInformation.parkingTransactionFeesVariable)}} {{('i18n.shared.currencies.' + Currency[parkingSession.detailedPriceInformation.currency]) | translate}}</span>
            </div>
            <div class="price-line price-sub">
              <span>{{'i18n.domain.parker-registration.parking-price-tooltip.vat-included' | translate}}</span>
              <span>{{formatPrice(parkingSession.detailedPriceInformation.vat)}} {{('i18n.shared.currencies.' + Currency[parkingSession.detailedPriceInformation.currency]) | translate}}</span>
            </div>
            <hr class="price-separator">
            <div class="price-line fw-semibold">
              <span>{{'i18n.domain.parker-registration.parking-price-tooltip.total-parking-price' | translate}}</span>
              <span>{{formatPrice(parkingSession.detailedPriceInformation.totalPriceWithVAT)}} {{('i18n.shared.currencies.' + Currency[parkingSession.detailedPriceInformation.currency]) | translate}}</span>
            </div>
          </div>
        </div>
      }
      @if (parkingSession.calculationRoadmap) {
        <div class="col-md-6">
          <label class="control-label">{{'i18n.domain.parker-registration.fields.calculationRoadmap' | translate}}</label>
          <div class="inner-card roadmap-container" [innerHTML]="formatRoadmap(parkingSession.calculationRoadmap)"></div>
        </div>
      }
    </div>
  }
</div>

<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.entry' | translate}}</div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}</label>
      <div>{{entry?.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm:ss')}}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.type' | translate}}</label>
      <div>{{getRegistrationType(entry) | translate}}</div>
    </div>
  </div>
  @if (exit?.type === 1) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
        <div>{{getRegisteredByText(entry)}}</div>
      </div>
    </div>
  }
  @if (entry?.mediaFiles?.length && entry?.offense === ParkerRegistrationOffense.NoOffense) {
    <div class="form-row row mb-0">
      <div class="form-group col-md-12">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.media-gallery' | translate}}</label>
        <div class="d-flex align-items-center flex-wrap">
          @for (imageId of entry.mediaFiles; track imageId) {
            <app-async-image [request]="getImageRequest(entry.id, imageId)"></app-async-image>
          }
        </div>
      </div>
    </div>
  }
</div>

@if (exit) {
  <div class="section-card">
    <div class="section-title">{{'i18n.domain.parker-registration.dialog.exit' | translate}}</div>
    <div class="form-row row">
      <div class="form-group col-md-6">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}</label>
        <div>{{exit?.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm:ss')}}</div>
      </div>
      <div class="form-group col-md-6">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.type' | translate}}</label>
        <div>{{getRegistrationType(exit) | translate}}</div>
      </div>
    </div>
    @if (exit?.type === 1) {
      <div class="form-row row">
        <div class="form-group col-md-6 mb-0">
          <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
          <div>{{getRegisteredByText(exit) | translate}}</div>
        </div>
      </div>
    }
    @if (exit?.mediaFiles?.length && exit?.offense === ParkerRegistrationOffense.NoOffense) {
      <div class="form-row row mb-0">
        <div class="form-group col-md-12">
          <label class="control-label">{{'i18n.domain.parker-registration.fields.media-gallery' | translate}}</label>
          <div class="d-flex align-items-center flex-wrap">
            @for (imageId of exit.mediaFiles; track imageId) {
              <app-async-image [request]="getImageRequest(exit.id, imageId)"></app-async-image>
            }
          </div>
        </div>
      </div>
    }
  </div>
}

@if (offenses && offenses.length > 0) {
  <div class="section-card section-card">
    <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-offenses' | translate}}</div>
    <ejs-tab>
      <e-tabitems>
        @for (offense of offenses; track offense) {
          <e-tabitem>
            <ng-template #headerTemplate>
              {{offense.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm')}}
            </ng-template>
            <ng-template #content>
              <app-parker-registration-detail-offense [offense]="offense" [displayIssuerName]="true">
              </app-parker-registration-detail-offense>
            </ng-template>
          </e-tabitem>
        }
      </e-tabitems>
    </ejs-tab>
  </div>
}
